export var DynamoDbBillingMode;
(function (DynamoDbBillingMode) {
    DynamoDbBillingMode["DYNAMODB_BILLING_MODE_UNSPECIFIED"] = "UNSPECIFIED";
    DynamoDbBillingMode["DYNAMODB_BILLING_MODE_PAY_PER_REQUEST"] = "PAY_PER_REQUEST";
    DynamoDbBillingMode["DYNAMODB_BILLING_MODE_PROVISIONED"] = "PROVISIONED";
})(DynamoDbBillingMode || (DynamoDbBillingMode = {}));
